import { type ComponentPropsWithRef, forwardRef, type ReactNode } from "react";
import { variant, container, labelText } from "./styles.css";

type Props = Omit<ComponentPropsWithRef<"input">, "type"> & {
  /*
    NOTE:label付きで扱う場合はhtmlForに渡すidが必要なので、必ずidと一緒に渡してください。
    labelだけを渡してもlabel付きのラジオボタンは表示されません。
  */
  id?: string;
  label?: string | ReactNode;
  hasError?: boolean;
};

/*
  TODO: forwardRefは非推奨なので、refをpropsに明示的に渡すように変更する。
  forwardRefを外すと、idとlabelの片方のみを渡すことを型レベルで防ぐように型を定義できる。

  type Props = Omit<ComponentPropsWithRef<"input">, "type"> & {
    hasError?: boolean;
  } & (WithLabelProps | WithoutLabelProps);

  type WithLabelProps = {
    id: string;
    label: string | ReactNode;
  };

  type WithoutLabelProps = {
    id?: never;
    label?: never;
  };
*/
export const RadioButton = forwardRef<HTMLInputElement, Props>(
  ({ label, className, hasError, "aria-label": ariaLabel, id, ...rest }, ref) => {
    const inputElement = (
      <input
        {...rest}
        id={id}
        type="radio"
        ref={ref}
        className={`${variant[hasError ? "hasError" : "default"]} ${className ?? ""}`}
        aria-label={typeof label === "string" ? label : ariaLabel}
      />
    );

    if (id && label) {
      return (
        <label className={container({ disabled: !!rest.disabled })} htmlFor={id}>
          {inputElement}
          <span className={labelText}>{label}</span>
        </label>
      );
    }

    return inputElement;
  },
);
RadioButton.displayName = "RadioButton";
